/* eslint-disable */
//Dark Theme
//Fleet/Vehicle/trip Summary card Icons
import AlertsDark from './assets/images/driving_analysis/dark-theme-alerts.svg';
import DistanceDark from './assets/images/driving_analysis/dark-theme-distance.svg';
import FuelDark from './assets/images/driving_analysis/dark-theme-fuel.svg';
import IdlingDark from './assets/images/driving_analysis/dark-theme-idling.svg';
import MilageDark from './assets/images/driving_analysis/dark-theme-milage.svg';
import RunningDark from './assets/images/driving_analysis/dark-theme-running.svg';
import StoppedDark from './assets/images/driving_analysis/dark-theme-stopped.svg';
import StopsDark from './assets/images/driving_analysis/dark-theme-stops.svg';
import durationDark from './assets/images/driving_analysis/dark-theme-duration.svg';
import speedDark from './assets/images/driving_analysis/dark-theme-speed.svg';
import utilizationDark from './assets/images/driving_analysis/dark-theme-utilization.svg';

//Alerts summary card Icons
import AlertCountDark from './assets/images/alerts/dark-theme-alerts-count.svg';
import VehicleCountDark from './assets/images/alerts/dark-theme-vehicle-count.svg';
import DPFREGENDark from './assets/images/alerts/dark-theme-dpf.svg';
import adblueLowDark from './assets/images/alerts/dark-theme-adblue-low.svg';
import adblueZoneDark from './assets/images/alerts/dark-theme-adblue-zone.svg';
import adblueFaultDark from './assets/images/alerts/dark-theme-adblue-fault.svg';
import engineOverrunDark from './assets/images/alerts/dark-theme-engine-overrun.svg';
import neutralDrivingDark from './assets/images/alerts/dark-theme-neutral-driving.svg';
import geofenceAltDark from './assets/images/alerts/dark-theme-geofence-alt.svg';
import fuelDropDark from './assets/images/alerts/dark-theme-fuel-drop.svg';
import fuelFillDark from './assets/images/alerts/dark-theme-fuel-fill.svg';
import overSpeedAltDark from './assets/images/alerts/dark-theme-overspeed-alt.svg';
import idlingAltDark from './assets/images/alerts/dark-theme-idling-alt.svg';
import uniqueGeofenceDark from './assets/images/alerts/dark-theme-unique-geofence.svg';
import totalEntryDark from './assets/images/alerts/dark-theme-total-entry.svg';
import totalExitDark from './assets/images/alerts/dark-theme-total-exit.svg';
import overspeedDurationDark from './assets/images/alerts/dark-theme-overspeed-duration.svg';
import neutralDurationDark from './assets/images/alerts/dark-theme-neutral-duration.svg';
import maxSpeedDark from './assets/images/alerts/dark-theme-max-speed.svg';
import idlingDurationDark from './assets/images/alerts/dark-theme-idiling-duration.svg';
import geofenceStopDark from './assets/images/alerts/dark-theme-geofence-stop.svg';
import stopDurationDark from './assets/images/alerts/dark-theme-stop-duration.svg';
import engineoverunDurationDark from './assets/images/alerts/dark-theme-engineover-duration.svg';
import maxRPMDark from './assets/images/alerts/dark-theme-max-RPM.svg';
import tripDelayDark from './assets/images/alerts/delay_icon-dark.svg';
import nightDrivingDark from './assets/images/alerts/night-driving-dark.svg';
import excessiveDrivingDark from './assets/images/alerts/excessive-drive-dark.svg';

// Pagination
import dropArrowDark from './assets/images/common/dark-theme-drop-arrow.svg';

//Light Theme
//Fleet/Vehicle/trip Summary card Icons
import AlertsLight from './assets/images/driving_analysis/light-theme-alerts.svg';
import DistanceLight from './assets/images/driving_analysis/light-theme-distance.svg';
import FuelLight from './assets/images/driving_analysis/light-theme-fuel.svg';
import IdlingLight from './assets/images/driving_analysis/light-theme-idling.svg';
import MilageLight from './assets/images/driving_analysis/light-theme-milage.svg';
import RunningLight from './assets/images/driving_analysis/light-theme-running.svg';
import StoppedLight from './assets/images/driving_analysis/light-theme-stopped.svg';
import StopsLight from './assets/images/driving_analysis/light-theme-stops.svg';
import durationLight from './assets/images/driving_analysis/light-theme-duration.svg';
import speedLight from './assets/images/driving_analysis/light-theme-speed.svg';
import utilizationLight from './assets/images/driving_analysis/light-theme-utilization.svg';

//Alerts summary card Icons
import AlertCountLight from './assets/images/alerts/light-theme-alerts-count.svg';
import VehicleCountLight from './assets/images/alerts/light-theme-vehicle-count.svg';
import DPFREGENLight from './assets/images/alerts/light-theme-dpf.svg';
import adblueLowLight from './assets/images/alerts/light-theme-adblue-low.svg';
import adblueZoneLight from './assets/images/alerts/light-theme-adblue-zone.svg';
import adblueFaultLight from './assets/images/alerts/light-theme-adblue-fault.svg';
import engineOverrunLight from './assets/images/alerts/light-theme-engine-overrun.svg';
import neutralDrivingLight from './assets/images/alerts/light-theme-neutral-driving.svg';
import geofenceAltLight from './assets/images/alerts/light-theme-geofence-alt.svg';
import fuelDropLight from './assets/images/alerts/light-theme-fuel-drop.svg';
import fuelFillLight from './assets/images/alerts/light-theme-fuel-fill.svg';
import overSpeedAltLight from './assets/images/alerts/light-theme-overspeed-alt.svg';
import idlingAltLight from './assets/images/alerts/light-theme-idling-alt.svg';
import uniqueGeofenceLight from './assets/images/alerts/light-theme-unique-geofence.svg';
import totalEntryLight from './assets/images/alerts/light-theme-total-entry.svg';
import totalExitLight from './assets/images/alerts/light-theme-total-exit.svg';
import overspeedDurationLight from './assets/images/alerts/light-theme-overspeed-duration.svg';
import neutralDurationLight from './assets/images/alerts/light-theme-neutral-duration.svg';
import maxSpeedLight from './assets/images/alerts/light-theme-max-speed.svg';
import idlingDurationLight from './assets/images/alerts/light-theme-idiling-duration.svg';
import geofenceStopLight from './assets/images/alerts/light-theme-geofence-stop.svg';
import stopDurationLight from './assets/images/alerts/light-theme-stop-duration.svg';
import engineoverunDurationLight from './assets/images/alerts/light-theme-engineover-duration.svg';
import maxRPMLight from './assets/images/alerts/light-theme-max-RPM.svg';
import tripDelayLight from './assets/images/alerts/delay_icon-light.svg';
import nightDrivingLight from './assets/images/alerts/night-driving-light.svg';
import excessiveDrivingLight from './assets/images/alerts/excessive-drive-light.svg';

// Pagination
import dropArrowLight from './assets/images/common/light-theme-drop-arrow.svg';
import { color } from 'highcharts';

export const darkTheme = {
  contentWrapper: {
    mainWrapper: {
      bgColor: '#121B21',
    },
    ownerWrapper: {
      bgColor: '#0a0e22',
    },
    homeText: {
      headingColor: '#fff',
      color: '#4659B9',
    },
    filter: {
      background: '#2A3338',
      color: '#ffffff',
    },
    filterBox: {
      bgColor: '#293237',
      color: '#fff',
    },
    selectedFilter: {
      bgColor: '#8A929733',
      color: '#fff',
      showmoreBg: '#2A3338',
    },
    datePicker: {
      bgColor: '#293237',
      color: '#fff',
      hoverbg: '#121B21',
    },
    footerWrapper: {
      bgColor: '#8a929733',
      color: '#fff',
    },
    genericTable: {
      tabHeader: '#0b1023',
      tabheaderFont: '#616472',
      tabheaderFontCol: '#ffffff',
      tableHeader: '#060818',
      tableHeaderFont: '#bdbdbd',
      tableBorder: '#121B21',
      even: '#3E464B',
      odd: '#2A3338',
      fontTable: '#a4a4a4',
      subAlertBg: '#afafb0',
      subAlertFont: '#3f3f3f',
    },
    locationShare: {
      bgColor: '#fff',
      opactity: '0.5',
      color: 'white',
    },
    locationShareSearch: {
      bgColor: 'none',
    },
    label: {
      themeChangeLabel: '#fff',
      themeChangeBg: '#293237',
    },
  },
  dashboardStyles: {
    cardBackground: {
      bgColor: 'rgba(138, 146, 151, 0.2)',
    },
    highchartsBackground: {
      fill: 'none',
    },
    cardHeading: {
      color: '#FFFFFF',
    },
    serviceCard: {
      bgColor: '#121B21',
      color: '#FFFFFF',
      border: '0.1rem #FFFFFF solid',
      boxShadow: '0 0 2rem 0 #FFFFFF40',
    },
  },
  tickerCarousel: {
    bgColor: '#2A3338',
    color: '#F1F1F1',
    notifyText: '#fff',
  },
  cardPrimary: {
    background: '#2A3338',
    color: '#ffffff',
    radius: '0.8rem',
    shadow: '#2e5bff12',
  },
  cardSecondary: {
    background: '#2A3338',
    color: '#ffffff',
    radius: '0.2rem',
    border: 'none',
    boxShadow: 'rgba(0, 0, 0, 0.38) 0 0 0.7rem',
  },
  trackTrace: {
    tripCard: { bgColor: 'rgb(103 120 147)' },
    geoFencCard: { bgColor: 'rgba(138, 146, 151, 0.2)' },
    geoFencCardHead: { bgColor: '#121B21', color: '#fff' },
    routePlayBack: {
      titleColor: '#fff',
      cardBgColor: '#8a929733',
      borderColor: '#3e464b',
    },
  },
  summaryStrip: {
    alerts: AlertsDark,
    distance: DistanceDark,
    fuel: FuelDark,
    idling: IdlingDark,
    mileage: MilageDark,
    running: RunningDark,
    stopped: StoppedDark,
    stops: StopsDark,
    duration: durationDark,
    speed: speedDark,
    utilization: utilizationDark,
  },
  alertStrip: {
    alertCount: AlertCountDark,
    vehicleCount: VehicleCountDark,
    dpfregen: DPFREGENDark,
    adblueLow: adblueLowDark,
    adblueZone: adblueZoneDark,
    adblueFault: adblueFaultDark,
    engineOverrun: engineOverrunDark,
    neutralDriving: neutralDrivingDark,
    geofenceAlt: geofenceAltDark,
    fuelDrop: fuelDropDark,
    fuelFill: fuelFillDark,
    overSpeedAlt: overSpeedAltDark,
    idlingAlt: idlingAltDark,
    uniqueGeofence: uniqueGeofenceDark,
    totalEntry: totalEntryDark,
    totalExit: totalExitDark,
    overspeedDuration: overspeedDurationDark,
    neutralDuration: neutralDurationDark,
    maxSpeed: maxSpeedDark,
    idlingDuration: idlingDurationDark,
    geofenceStop: geofenceStopDark,
    stopDuration: stopDurationDark,
    engineoverunDuration: engineoverunDurationDark,
    maxRPM: maxRPMDark,
    tripDelay: tripDelayDark,
    nightDriving: nightDrivingDark,
    excessiveDriving: excessiveDrivingDark,
  },
  alertsNotification: {
    cardBgColor: '#8A929733',
    cardText: '#fff',
    innerCardBg: '#8A929733',
    innerText: '#fff',
    accordionBg: '#fff',
    accordionBorder: '0.1rem #121B21 solid',
    accordionBorderColor: '#121B21',
    alertHeading: '#fff',
  },
  shareReports: {
    color: '#fff',
    border: '0.1rem #8A9297 solid',
  },
  fleetHealth: {
    cardBg: '#2A3338',
    color: '#fff',
    subCardBg: '#4E555A',
    serviceBg: '#121B21',
    serviceBorder: '0.1rem #4E555A solid',
  },
  pagination: {
    dropArrow: dropArrowDark,
  },
  trends: {
    cardBg: '#2A3338',
    tileBg: '#8A929733',
    color: '#fff',
    tileBorder: '#3e464b',
  },
  settings: {
    bgColor: '#2A3338',
    color: '#fff',
    odd: '#8A929733',
    even: 'none',
    cdsService: '#3E464B',
    cdsServiceText: '#CED8DE',
    cdsRequestbg: '#8A929733',
    headerBorder: '#121B21',
    infoBox: '#3E464B',
    infoBorder: '0.1rem solida #121B21',
  },
  settingsPoi: {
    bgColor: '#A70E13',
    color: '#fff',
  },
  modal: {
    overlay: '#121B2199',
    wrapper: '#273035',
    innerBg: '#121B21',
    popupBg: '#2A3338',
    boxShadow: '0 0.4rem 2rem 0 #FFFFFF40',
    innerCard: '#8A929733',
    inputFocus: '#fff',
  },
  dropdown: {
    bgColor: '#2a3338',
  },
  drivingAnalysis: {
    color: '#121B21',
    barColor: '#121B21',
    strokeColor: '#2A3338',
  },
  tripManagement: {
    bgColor: '#2A3338',
    color: '#fff',
  },
  profile: {
    bgColor: '#8A929733',
    border: '0.1rem #121B21 solid',
  },
  singleUpdate: {
    bgColor: '#2A3338',
  },
  navigationDatepickerPrev: {
    borderRightColor: '#CED8DE',
  },
  navigationDatepickerNext: {
    borderLeftColor: '#CED8DE',
  },
  darrkThemeColor: {
    bgColor: '#2A3338',
    color: '#fff',
  },
  helpFooter: {
    bgColor: '#2A3338',
    color: '#fff',
  },
  disabledColor: {
    color: '#8a9297',
  },
};

export const lightTheme = {
  contentWrapper: {
    mainWrapper: {
      bgColor: '#CED8DE',
    },
    ownerWrapper: {
      bgColor: '#F5F6FB',
    },
    homeText: {
      headingColor: '#121B21',
      color: '#4659B9',
    },
    filter: {
      background: '#fff',
      color: '#121B21',
    },
    filterBox: {
      bgColor: '#fff',
      color: '#000',
    },
    selectedFilter: {
      bgColor: '#fff',
      color: '#121B21',
      showmoreBg: '#fff',
    },
    datePicker: {
      bgColor: '#fff',
      color: '#121B21',
      hoverbg: '#ced8de',
    },
    footerWrapper: {
      bgColor: '#fff',
      color: '#121B21',
    },
    genericTable: {
      tabHeader: '#CDE6FF',
      tabheaderFont: '#333',
      tabheaderFontCol: '#333333',
      tableHeader: '#003171',
      tableHeaderFont: '#fff',
      tableBorder: '#CED8DE',
      even: '#F1F4F6',
      odd: '#FFFFFF',
      fontTable: '#4F4F4F',
      subAlertBg: '#fff',
      subAlertFont: '#4F4F4F',
    },
    locationShare: {
      bgColor: '#8A9297',
      opactity: '1',
      color: 'black',
    },
    locationShareSearch: {
      bgColor: '#fff',
    },
    label: {
      themeChangeLabel: '#121B21',
      themeChangeBg: '#fff',
    },
  },
  dashboardStyles: {
    cardBackground: {
      bgColor: '#fff',
    },
    highchartsBackground: {
      fill: '#fff',
    },
    cardHeading: {
      color: '#121B21',
    },
    serviceCard: {
      bgColor: '#fff',
      color: '#121B21',
      border: '0.1rem #8A9297 solid',
      boxShadow: '0 0 2rem 0 #00000040',
    },
  },
  tickerCarousel: {
    bgColor: '#FFFFFF',
    color: '#121B21',
    notifyText: '#A70E13',
  },
  cardPrimary: {
    background: '#ffffff',
    color: '#212529',
    radius: '0.8rem',
    shadow: '#2e5bff12',
  },
  cardSecondary: {
    background: '#ffffff',
    color: '#212529',
    radius: '0.2rem',
    border: '0.2rem solid #f3f2f2',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0 0 0.3rem',
  },
  trackTrace: {
    tripCard: { bgColor: '#e6eefa' },
    geoFencCard: { bgColor: '#F1F4F6' },
    geoFencCardHead: { bgColor: '#CED8DE', color: '#121B21' },
    routePlayBack: {
      titleColor: '#000',
      cardBgColor: 'rgba(206, 216, 222, 0.3)',
      borderColor: '#f0f3f5',
    },
  },
  summaryStrip: {
    alerts: AlertsLight,
    distance: DistanceLight,
    fuel: FuelLight,
    idling: IdlingLight,
    mileage: MilageLight,
    running: RunningLight,
    stopped: StoppedLight,
    stops: StopsLight,
    duration: durationLight,
    speed: speedLight,
    utilization: utilizationLight,
  },
  alertStrip: {
    alertCount: AlertCountLight,
    vehicleCount: VehicleCountLight,
    dpfregen: DPFREGENLight,
    adblueLow: adblueLowLight,
    adblueZone: adblueZoneLight,
    adblueFault: adblueFaultLight,
    engineOverrun: engineOverrunLight,
    neutralDriving: neutralDrivingLight,
    geofenceAlt: geofenceAltLight,
    fuelDrop: fuelDropLight,
    fuelFill: fuelFillLight,
    overSpeedAlt: overSpeedAltLight,
    idlingAlt: idlingAltLight,
    uniqueGeofence: uniqueGeofenceLight,
    totalEntry: totalEntryLight,
    totalExit: totalExitLight,
    overspeedDuration: overspeedDurationLight,
    neutralDuration: neutralDurationLight,
    maxSpeed: maxSpeedLight,
    idlingDuration: idlingDurationLight,
    geofenceStop: geofenceStopLight,
    stopDuration: stopDurationLight,
    engineoverunDuration: engineoverunDurationLight,
    maxRPM: maxRPMLight,
    tripDelay: tripDelayLight,
    nightDriving: nightDrivingLight,
    excessiveDriving: excessiveDrivingLight,
  },
  alertsNotification: {
    cardBgColor: '#fff',
    cardText: '#121B21',
    innerCardBg: '#fff',
    innerText: '#A70E13',
    accordionBg: '#8A929733',
    accordionBorder: '0.1rem #CED8DE solid',
    accordionBorderColor: '#CED8DE',
    alertHeading: '#121B21',
  },
  shareReports: {
    color: '#121B21',
    border: '0.1rem #CED8DE solid',
  },
  fleetHealth: {
    cardBg: '#fff',
    color: '#121B21',
    subCardBg: '#CED8DE',
    serviceBg: '#CED8DE',
    serviceBorder: '0.1rem #CAC3CA solid',
  },
  pagination: {
    dropArrow: dropArrowLight,
  },
  trends: {
    cardBg: '#fff',
    tileBg: '#CED8DE4D',
    color: '#121B21',
    tileBorder: '#f0f3f5',
  },
  settings: {
    bgColor: '#fff',
    color: '#121B21',
    odd: '#F1F4F6',
    even: '#FFFFFF',
    cdsService: '##CED8DE4D',
    cdsServiceText: '#8A9297',
    cdsRequestbg: '#F1F4F6',
    headerBorder: '#CED8DE',
    infoBox: '#F1F4F6',
    infoBorder: '0.1rem solida #CED8DE',
  },
  settingsPoi: {
    bgColor: '#A70E13',
    color: '#fff',
  },
  modal: {
    overlay: '#FFFFFFCC',
    wrapper: '#CED8DE',
    innerBg: '#fff',
    popupBg: '#fff',
    boxShadow: '0 0.4rem 2rem 0 #00000040',
    innerCard: '#CED8DE80',
    inputFocus: '#121B21',
  },
  dropdown: {
    bgColor: '#fff',
  },
  drivingAnalysis: {
    color: '#fff',
    barColor: '#CED8DE',
    strokeColor: '#fff',
  },
  tripManagement: {
    bgColor: '#fff',
    color: '#121B21',
  },
  profile: {
    bgColor: '#fff',
    border: '0.1rem #CED8DE solid',
  },
  singleUpdate: {
    bgColor: '#fff',
  },
  navigationDatepickerPrev: {
    borderRightColor: '#333',
  },
  navigationDatepickerNext: {
    borderLeftColor: '#333',
  },
  darrkThemeColor: {
    bgColor: '#fff',
    color: '#121B21',
  },
  helpFooter: {
    bgColor: '#fff',
    color: 'black',
  },
  disabledColor: {
    color: '#ccc',
  },
};
